(function($) {
    var tapping = false,
        ofnbody = $('body'),
        offCanvasNavRightClass = 'off-canvas-right',
        navInClass = 'js-off-canvas-showing',
        siteHeaderFixedClass = 'header-fixed',
        offCanvasOverlayClass = 'l-off-canvas-overlay',
        canvas = $('.l-canvas'),
        headerHeight = $('.l-header').outerHeight(),
        touchStartX,
        touchStartY,
        docScrollLoc = 0,
        currentLoc = 0;

    function isiOS() {
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            ofnbody.addClass('is-ios');
            return true;
        } else {
            return false;
        }
    };

    function toggleOffCanvas() {
        docScrollLoc = $(document).scrollTop();

        if (ofnbody.hasClass(navInClass)) {
            ofnbody.removeClass(navInClass);

            /* iOS Safari scroll canvas to the original canvas position */
            if (isiOS() && ofnbody.hasClass(siteHeaderFixedClass)) {
                canvas.removeAttr('style');
                $('body').animate({
                    scrollTop: currentLoc
                }, 0);
            }
        } else {
            /* iOS Safar set location of canvas so the user doesn't lose where they are */
            if (isiOS() && ofnbody.hasClass(siteHeaderFixedClass)) {
                canvas.css({
                    'top': -(docScrollLoc - headerHeight)
                });
            }

            ofnbody.addClass(navInClass);
            currentLoc = docScrollLoc;
        }
    };

    function offCanvas() {
        /* Build overlay that covers up the page content so it can't be interacted with when off canvas nav is enabled */
        $('.l-surround').prepend('<div class="' + offCanvasOverlayClass + '"></div>');

        /* Get X location of user touch */
        ofnbody.bind('touchstart', function(e) {
            touchStartX = e.originalEvent.touches[0].clientX;
        });

        ofnbody.bind('touchmove', function(e) {
            var touchRight = e.originalEvent.changedTouches[0].clientX;
            if (touchStartX - 80 > touchRight && ofnbody.hasClass(navInClass) &&
                !ofnbody.hasClass(offCanvasNavRightClass) && tapping !== true) {
                toggleOffCanvas();
            } else if (touchStartX + 80 < touchRight && ofnbody.hasClass(navInClass) &&
                ofnbody.hasClass(offCanvasNavRightClass) && tapping !== true) {
                toggleOffCanvas();
            }
        });

        /* If user clicks (or taps) close the off canvas nav */
        $('.btn-off-canvas-toggle, .' + offCanvasOverlayClass).on('click', function() {
            toggleOffCanvas();
        });
    };

    /* Document ready */
    $(document).ready(function() {
        offCanvas();
    });
}(jQuery));
